import { createStructuredSelector } from 'reselect';
import getActiveFilters from './getActiveFilters';

export default createStructuredSelector({
  filters: getActiveFilters,
});
